import React from 'react'
import ICSButton from '../../components/ICS/Button/ICSButton'
import { Row, ModalBody } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { isRegistrationEnabled } from '../../redux/slices'

const LostPasswordNotifyAdmin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleClick = () => {
    dispatch(isRegistrationEnabled())
    navigate('/ui2/login')
  }
  return (
    <ModalBody>
      <Row>
        <>Your administrators have been notified you're requesting a password reset.</>
      </Row>
      <Row className='reset-btn-row'>
        <ICSButton
          className='reset-confirm'
          id='form_cancel'
          width={60}
          type='success'
          onClick={handleClick}
          useSubmitBehavior={false}
        >
          Okay
        </ICSButton>
      </Row>
    </ModalBody>
  )
}

export default LostPasswordNotifyAdmin
